module.exports = __webpack_public_path__ + "img/mobile_group_banner.c4ba2bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterAd/image/mobile_group_banner.png
// module id = r3FF
// module chunks = 0